import { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { CkEditor, Editors } from "../../../../Constants/Constants";
import Editor from "./Editor";
import InlineEditor from "./InlineEditor";

const CkEditorContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={CkEditor} parent={Editors} />
      <Container fluid>
        <Row>
          <Editor />
          <InlineEditor />
        </Row>
      </Container>
    </Fragment>
  );
};

export default CkEditorContainer;
